import { render, staticRenderFns } from "./NoteSynopsis.vue?vue&type=template&id=6e39b8bb&"
import script from "./NoteSynopsis.vue?vue&type=script&lang=js&"
export * from "./NoteSynopsis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports